/**
 * R5FilterRow
 * -----------------------------------------------------------
 * Presentational filter bar: search input + selects + chips.
 * Parent owns state — pass `children` for full control or use
 * the convenience props for simple cases.
 *
 * Convenience props:
 *   search:  { value, onChange, placeholder }
 *   selects: [{ value, onChange, options:[{value,label}], placeholder? }]
 *   chips:   [{ label, active?, onClick? }]
 *
 * Or just pass `children` and arrange the parts yourself.
 */
import React from 'react';

export function R5FilterRow({
  search,
  selects = [],
  chips = [],
  children,
  className = '',
  ...rest
}) {
  const cls = ['r5-filter-row', className].filter(Boolean).join(' ');
  return (
    <div className={cls} role="search" {...rest}>
      {children !== undefined ? (
        children
      ) : (
        <>
          {search && (
            <input
              type="search"
              className="r5-filter-row__input"
              value={search.value || ''}
              onChange={(e) => search.onChange && search.onChange(e.target.value)}
              placeholder={search.placeholder || 'Search…'}
              aria-label={search.placeholder || 'Search'}
            />
          )}
          {selects.map((sel, i) => (
            <select
              key={i}
              className="r5-filter-row__select"
              value={sel.value || ''}
              onChange={(e) => sel.onChange && sel.onChange(e.target.value)}
              aria-label={sel.placeholder || `Filter ${i + 1}`}
            >
              {sel.placeholder && <option value="">{sel.placeholder}</option>}
              {(sel.options || []).map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          ))}
          {chips.map((chip, i) => (
            <button
              key={i}
              type="button"
              className="r5-filter-row__chip"
              aria-pressed={chip.active ? 'true' : 'false'}
              onClick={chip.onClick}
              style={chip.active ? { background: 'var(--brand-brass)', color: 'var(--brand-navy)' } : undefined}
            >
              {chip.label}
            </button>
          ))}
        </>
      )}
    </div>
  );
}

export default R5FilterRow;
